import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable — BENZENATI" description="La page demandée est introuvable." />
      <section className="mx-auto flex max-w-3xl flex-col items-start px-6 py-32 lg:py-48" data-testid="notfound-page">
        <span className="font-serif text-6xl text-bz-amber">404</span>
        <h1 className="mt-6 font-serif text-4xl text-bz-navy lg:text-5xl">Page introuvable</h1>
        <p className="mt-6 text-lg leading-relaxed text-bz-slate">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-10 inline-flex items-center border border-bz-navy px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-navy transition-colors duration-300 hover:bg-bz-navy hover:text-bz-ivory"
        >
          Retour à l'accueil
        </Link>
      </section>
    </>
  );
}
